// UploadVideo.tsx
import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { toAbsoluteUrl } from '../../AssetHelpers'

function UploadVideo({ label, name, formik, required = true }: any) {
    const [errorMessage, setErrorMessage] = useState('')
    const [isVideoUploaded, setIsVideoUploaded] = useState(false)

    // Check if there's already a video value on component mount
    useEffect(() => {
        if (formik.values[name]) {
            setIsVideoUploaded(true)
        }
    }, [formik.values[name], name])

    const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files ? event.target.files[0] : null
        if (!file) return

        // Check file size (50 MB limit for videos)
        if (file.size > 52428800) {
            setErrorMessage('Max file size is 2 MB.')
            return
        }

        setErrorMessage('')
        const formData = new FormData()
        formData.append('file', file)

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_BASE_API_URL}upload/video`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        token: 'Bearer eyJ0eXBlIjoiSldUIiwiYWxnIjoiSFMyNTYifQ.eyJjcmVhdGVkVGltZSI6MTY5MzMyMTg2MDU1MCwiZXhwaXJ5VGltZSI6MTY5MzMyMTg5MDU1MCwidXNlclR5cGUiOiJTTUFSVF9DRU5UUkUiLCJ1c2VySWQiOiI2NGM5NDRhMWUwZDQzMTU1MDE1ZmJjYzIifQ.MOqTincx0tq--3BvYrH2WsM4PvydIMiKY2ZDj5ImaGQ'
                    },
                }
            )
            const uploadedUrl = response?.data?.data?.name
            if (uploadedUrl) {
                formik.setFieldValue(name, response.data.data.name)
                setIsVideoUploaded(true)
            }
        } catch (error) {
            console.error('Error uploading video:', error)
            setErrorMessage('Failed to upload the video. Please try again.')
        }
    }

    const blankVideo = toAbsoluteUrl('/media/svg/files/blank-video.svg')

    return (
        <div className='fv-row mb-7'>
            <label className={`d-block ${required ? 'required' : ''} fw-bold fs-6 mb-5`}>{label}</label>
            <div className='d-flex flex-wrap gap-3'>
                <div
                    className='image-input image-input-outline'
                    data-kt-image-input='true'
                    style={{ backgroundImage: `url('${blankVideo}')` }}
                >
                    <div
                        className='image-input-wrapper w-100px h-100px d-flex align-items-center justify-content-center'
                        style={{
                            backgroundColor: isVideoUploaded ? '#f8f9fa' : 'transparent',
                            border: isVideoUploaded ? '2px solid #1bc5bd' : '1px solid #e4e6ea',
                            backgroundImage: isVideoUploaded ? 'none' : `url('${blankVideo}')`
                        }}
                    >
                        {isVideoUploaded && (
                            <i className="fas fa-video text-success" style={{ fontSize: '24px' }}></i>
                        )}
                    </div>
                    <label
                        className='btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow'
                        data-kt-image-input-action='change'
                        data-bs-toggle='tooltip'
                        title='Upload video'
                    >
                        <i className='bi bi-plus fs-7'></i>
                        <input
                            type='file'
                            name='video'
                            accept='.mp4, .avi, .mov, .wmv'
                            onChange={handleFileChange}
                        />
                    </label>
                </div>
            </div>
            <div className='form-text'>Allowed file types: <br /> mp4,webm, Max file size <span style={{ marginLeft: '20px' }}></span>
         <br /> 10 MB</div>
            {errorMessage && <div className='text-danger mt-2'>{errorMessage}</div>}
        </div>
    )
}

export default UploadVideo